export enum NOTIFICATIONS_RULE_CODE {
  NEW_INVOICES_AVAILABLE_DOWNLOAD_NOTIFICATION_RULE = "new_invoices_available_download_notification_rule",
  MARKETING_COMMUNICATIONS_NOTIFICATION_RULE = "marketing_communications_notification_rule",
  ACCOUNT_DEACTIVATION_NOTIFICATION_RULE = "account_deactivation_notification_rule",
  PASSWORD_RESET_NOTIFICATION_RULE = "password_reset_notification_rule",
  ROLE_ACCOUNT_CHANGES_NOTIFICATION_RULE = "role_account_changes_notification_rule",
  CONFIRM_LOCATION_UPDATE_NOTIFICATION_RULE = "confirm_location_update_notification_rule",
  CONFIRM_ONBOARDING_NEW_LOCATION_NOTIFICATION_RULE = "confirm_onboarding_new_location_notification_rule",
  LOCATION_UPDATE_NOTIFICATION_RULE = "location_update_notification_rule",
  ONBOARDING_NEW_LOCATION_NOTIFICATION_RULE = "onboarding_new_location_notification_rule",
  REMINDER_TEMP_CLOSE_LOCATION_NOTIFICATION_RULE = "reminder_temp_close_location_notification_rule",
  PRODUCT_NEWS_ANNOUNCEMENTS_NOTIFICATION_RULE = "product_news_announcements_notification_rule",
}
